import { PropsWithChildren } from "react";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Popup } from "@/Common/Components/Modals/Popup";

interface ImmunizationProfileSectionPopupProps {
    id: string;
    title: string;
    style?: React.CSSProperties;
    isLoading?: boolean;

    onClose: () => void;
    onSave: () => void;

    width: number;
    height?: number;
    top?: number;

    isValid: boolean;
    isModifying: boolean;
    modifyButtonLabel: string;
}

class ImmunizationProfileSectionPopup extends BaseReactComponent<PropsWithChildren<ImmunizationProfileSectionPopupProps>, null> {
    public render(): JSX.Element {
        return (
            <Popup
                Id={this.props.id}
                title={this.props.title}
                centeredHorizontally
                draggable={false}
                width={this.props.width}
                topPosition={this.props.top ?? null}
                style={{ display: "flex", flexFlow: "column", minHeight: this.props.height }}
                altView
            >
                <div className="p-header">
                    <a className="close" aria-label="Close" onClick={() => this.props.onClose()}> ×</a>
                    <h4>{this.props.title}</h4>
                </div>
                <div className="p-body" style={{ alignSelf: "stretch", flexGrow: 1, overflowY: "visible" }}>
                    {this.props.children}
                </div>
                <div className="p-footer">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 text-right">
                            <button
                                className="btn btn-default push-right-5"
                                onClick={() => this.props.onClose()}
                            >
                                {cacheStore.GetString(this.props.isModifying ? "CancelLabel" : "CloseLabel")}
                            </button>
                            {this.props.isModifying && (
                                <button
                                    disabled={this.props.isLoading || !this.props.isValid}
                                    className="btn btn-primary"
                                    onClick={() => this.props.onSave()}
                                >
                                    {cacheStore.GetString(this.props.modifyButtonLabel)}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </Popup>
        );
    }
}

export { ImmunizationProfileSectionPopup };
